let cardStatusDic = {
    "停机": '3',
    "未激活": '0',
    "已激活": '1'
}
function getMatchNumber (str) {
    return str.match(/\d+/g)[0]
}

function getDateTimestamp (str) {
    return new Date(str).getTime();
}
export function reCorrectLineArr(lineArr) {
    if (lineArr[11] && lineArr[11] !== 'null' && !/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/.test(lineArr[11])) {
        lineArr[10] += '，' + lineArr[11];
        lineArr.splice(11, 1);
    }
}
export class SimCard {
    constructor(lineArr) {
        this.operator = lineArr[0];
        this.open_time = getDateTimestamp(lineArr[1]);
        this.iccid = getMatchNumber(lineArr[6]);
        this.imsi = getMatchNumber(lineArr[4]);
        this.msisdn = lineArr[15];
        this.card_status = cardStatusDic[lineArr[13]] || '0';
        this.force_active_time = lineArr[14].includes('已激活') ? null : getDateTimestamp(lineArr[14]);
        this.expire_date = getDateTimestamp(lineArr[7].substr(lineArr[7].indexOf('\~') + 1));
        this.active_time = (lineArr[11] && lineArr[11] !== 'null' && getDateTimestamp(lineArr[11])) || null;
        this.flow_total = parseInt(lineArr[5]) + parseInt(lineArr[8]);
        this.flow_used = parseInt(lineArr[5]);
        this.card_from = 0;
        this.card_gen = 4;
    }
}
export class Taocan {
// {effectiveTime: "2020-04-09 11:00:16", 
// expireTime: "2020-04-30 23:59:59", 
// offerId: "22010000244065", 
// offerName: "物联网-移动-通用-单卡1G月包", 
// orderTime: "2020-04-09 12:00:26"}
    constructor(lineArr) {
        this.offerName = lineArr[3];
        this.effectiveTime = getDateTimestamp(lineArr[7].substr(0, 10));
        this.expireTime = getDateTimestamp(lineArr[7].substr(lineArr[7].indexOf('\~') + 1));
    }
}